<div class="sp-dialog__max-width-m sp-dialog__min-width">
  <div class="sp-padding__x2">
    <h3 class="sp-color__accent">{{ 'BUYERS.CONFIRM_USER_TITLE' | translate }}</h3>
    <div class="sp-color__accent sp-padding"></div>
    <div
      *ngIf="buyer?.is_confirmed && buyer?.confirmed_by"
      class="sp-width__full sp-margin__top">
      <span> {{ 'BUYERS.CONFIRMED_BY_LABEL' | translate }}: {{ buyer?.confirmed_by_ext_id ?? '' }} </span>
    </div>
    <form
      [formGroup]="confirm_otp_form_group"
      class="sp-margin__top-x2 sp-row__space sp-wrap">
      <mat-form-field
        class="sp-width__full"
        appearance="fill"
        color="accent">
        <mat-label>
          {{ 'BUYERS.CONFIRM_REASON_LABEL' | translate }}
        </mat-label>
        <textarea
          matInput
          type="text"
          formControlName="confirm_reason"
          style="min-height: 100px"
          [readonly]="buyer?.is_confirmed && buyer?.confirmed_by"
          [errorStateMatcher]="error_matcher"></textarea>
      </mat-form-field>

      <div
        *ngIf="!buyer?.is_confirmed"
        class="sp-margin__top-x4 sp-width__full">
        <app-shared-button
          class="sp-width__full"
          [cta]="'BUYERS.CONFIRM_REASON_CTA' | translate"
          [is_disabled]="!isFormValid() || is_confirming_otp_running || buyer?.is_confirmed"
          (button_click)="onSetNoteClick()"></app-shared-button>
      </div>
    </form>
  </div>
  <div
    *ngIf="is_confirming_otp_running"
    class="sp-column__center sp-width__full sp-padding__x2">
    <mat-spinner
      color="accent"
      diameter="40"></mat-spinner>
    <p class="sp-color__accent sp-text__center sp-margin__top">Loading...</p>
  </div>
</div>
